export default __webpack_public_path__ + "static/media/mehmed1.8ef588a5.png";